<template>
  <!-- 资金安全 · 传统金融路径 vs 数字货币路径对比（原信息图的 HTML/CSS 复刻） -->
  <div class="path-compare">
    <!-- 传统金融路径 -->
    <section class="path-row">
      <p class="path-caption path-caption--traditional">
        {{ $t("fundSafety.d1TraditionalTitle") }}
      </p>
      <div class="path-flow">
        <div class="path-node">{{ $t("fundSafety.d1T1") }}</div>
        <span
          class="path-arrow path-arrow--danger is-dashed"
          aria-hidden="true"
        ></span>
        <div class="path-node">{{ $t("fundSafety.d1T2") }}</div>
        <span
          class="path-arrow path-arrow--danger is-dashed"
          aria-hidden="true"
        ></span>
        <div class="path-node">{{ $t("fundSafety.d1T3") }}</div>
        <span
          class="path-arrow path-arrow--danger is-dashed"
          aria-hidden="true"
        ></span>
        <div class="path-node">{{ $t("fundSafety.d1T4") }}</div>
        <span class="path-arrow path-arrow--danger" aria-hidden="true"></span>
        <div class="path-node path-node--danger">
          {{ $t("fundSafety.d1T5") }}
        </div>
      </div>
    </section>

    <!-- 数字货币路径 -->
    <section class="path-row">
      <p class="path-caption path-caption--digital">
        {{ $t("fundSafety.d1DigitalTitle") }}
      </p>
      <div class="path-flow">
        <div class="path-node path-node--primary">
          {{ $t("fundSafety.d1D1") }}
        </div>
        <span
          class="path-arrow path-arrow--primary is-dashed"
          aria-hidden="true"
        ></span>
        <div class="path-node path-node--core">
          <strong>{{ $t("fundSafety.d1D2") }}</strong>
          <span>{{ $t("fundSafety.d1D2Sub") }}</span>
        </div>
        <span
          class="path-arrow path-arrow--primary is-dashed"
          aria-hidden="true"
        ></span>
        <div class="path-node path-node--success">
          {{ $t("fundSafety.d1D3") }}
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "FundPathCompare",
};
</script>

<style scoped>
.path-compare {
  padding: 24px 26px;
  border-radius: 16px;
  border: 1px solid rgba(0, 180, 255, 0.14);
  background: radial-gradient(
      120% 140% at 0% 0%,
      rgba(0, 180, 255, 0.12),
      transparent 58%
    ),
    linear-gradient(180deg, #0a1727 0%, #070d17 100%);
  box-shadow: 0 24px 48px -34px rgba(0, 0, 0, 0.95);
}

.path-row + .path-row {
  margin-top: 26px;
}

.path-caption {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
  line-height: 1.5;
}

.path-caption::before {
  content: "";
  flex: 0 0 auto;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  box-shadow: 0 0 8px currentColor;
}

.path-caption--traditional {
  color: rgba(255, 255, 255, 0.6);
}

.path-caption--digital {
  color: #38bdf8;
}

.path-flow {
  display: flex;
  align-items: stretch;
}

.path-node {
  flex: 0 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 11px 16px;
  border-radius: 9px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.055);
  color: rgba(255, 255, 255, 0.86);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.45;
  text-align: center;
  word-break: break-word;
  transition: border-color 0.25s, background 0.25s;
}

.path-node:hover {
  border-color: rgba(255, 255, 255, 0.22);
}

/* 终点：传统路径（暗红） */
.path-node--danger {
  border-color: rgba(255, 108, 96, 0.8);
  background: linear-gradient(135deg, #b32b25, #7c1a16);
  color: #fff;
  box-shadow: 0 12px 26px -16px rgba(220, 38, 38, 0.95);
}

/* 起点：数字货币（亮蓝） */
.path-node--primary {
  border-color: rgba(96, 165, 250, 0.85);
  background: linear-gradient(135deg, #2a7bff, #1553b8);
  color: #fff;
  box-shadow: 0 12px 26px -14px rgba(37, 99, 235, 0.95);
}

/* 中段：区块链核心（描边 + 副说明） */
.path-node--core {
  flex-direction: column;
  gap: 6px;
  padding: 13px 22px;
  border: 2px solid #1d6fe8;
  background: rgba(8, 32, 64, 0.55);
  box-shadow: 0 0 0 1px rgba(0, 180, 255, 0.16),
    0 18px 34px -26px rgba(0, 140, 255, 0.95);
}

.path-node--core strong {
  color: #38bdf8;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
}

.path-node--core span {
  color: rgba(255, 255, 255, 0.55);
  font-size: 11.5px;
  font-weight: 500;
  line-height: 1.5;
}

/* 终点：数字化（绿） */
.path-node--success {
  border-color: rgba(34, 197, 94, 0.75);
  background: rgba(6, 78, 59, 0.5);
  color: #4ade80;
  font-weight: 700;
  box-shadow: 0 12px 26px -18px rgba(34, 197, 94, 0.95);
}

/* 连接线：默认实线，is-dashed 为虚线 */
.path-arrow {
  --line-color: #e04b3c;
  position: relative;
  flex: 1 1 26px;
  min-width: 26px;
  height: 2px;
  align-self: center;
  margin: 0 6px;
  background: var(--line-color);
}

.path-arrow--primary {
  --line-color: #1d9bf0;
}

.path-arrow.is-dashed {
  background: none;
  background-image: repeating-linear-gradient(
    90deg,
    var(--line-color) 0 7px,
    transparent 7px 13px
  );
}

.path-arrow::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -1px;
  transform: translateY(-50%);
  border-left: 7px solid var(--line-color);
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
}

/* 窄屏：流程纵向排列，箭头朝下 */
@media (max-width: 1100px) {
  .path-compare {
    padding: 18px 16px;
  }

  .path-flow {
    flex-direction: column;
    align-items: stretch;
  }

  .path-node {
    width: 100%;
  }

  .path-arrow {
    flex: 0 0 22px;
    width: 2px;
    height: 22px;
    min-width: 0;
    margin: 2px auto;
  }

  .path-arrow.is-dashed {
    background-image: repeating-linear-gradient(
      180deg,
      var(--line-color) 0 7px,
      transparent 7px 13px
    );
  }

  .path-arrow::after {
    top: auto;
    bottom: -1px;
    right: auto;
    left: 50%;
    transform: translateX(-50%);
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 7px solid var(--line-color);
    border-bottom: 0;
  }
}
</style>
